const ListTable = require('app/ui/list/Table');

class LogsTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'product': {'id':null,'name':null},
            'length': 25,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.buildGraphQLParameters = this.buildGraphQLParameters.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.product = this.settings.product;
        if(!this.product.id){
            window.notify("Missing valid product","error");
        }

        this.initialize();
    }

    initialize() {
        var self = this;

        this.buildTab();
    }


    onDOMReady(){

    }

    buildTab(data){
        this.$tableContainer = $('<div/>');

        this.$container
        .html('')
        .append(this.$tableContainer);


        this.initializeListTable();

        this.onDOMReady();
    }


    initializeListTable(){
        var self = this;

        let fields = [
            'createdAt',
            'restaurant { id name }',
            'user { id firstName lastName }',
            'oldPrice',
            'newPrice',
            'type',
            'sector { id name }',
        ];

        this.table = new ListTable({
            '$container': this.$tableContainer,
            'tableClass': 'table table-striped product-logs-list',
            'id': 'list-products',
            'length': this.settings.length,
            'graphQL': {
                'queryType': 'restaurantProductPriceUpdateLogs',
                'fields': fields,
                'parameters': this.buildGraphQLParameters,

            },
            'columns': [
                {
                    'name': 'createdAt',
                    'label': window.translate('app.product.show.tabs.logs.createdAt.label'),
                    'orderType': 'createdAt',
                    'class': 'product-logs-createdAt',
                    'render': function(item,index){
                        return window.formatDate(item.node.createdAt,window.translate('momentDateFormat.fullDayTime'))
                    },
                },
                {
                    'name': 'user',
                    'label': window.translate('app.product.show.tabs.logs.user.label'),
                    'ordered': true,
                    'orderType': 'user',
                    'orderDir': 'ASC',
                    'class': 'product-logs-user',
                    'render': function(item,index){
                        if(item.node.user && item.node.user.id > 0){
                            return item.node.user.firstName + ' ' + item.node.user.lastName;
                        }else{
                            return window.translate('corruptedData');
                        }
                    },
                },
                {
                    'name': 'restaurant',
                    'label': window.translate('app.product.show.tabs.logs.restaurant.label'),
                    'ordered': true,
                    'orderType': 'restaurant',
                    'orderDir': 'ASC',
                    'class': 'product-logs-restaurant',
                    'render': function(item,index){
                        if(item.node.restaurant && item.node.restaurant.id > 0){
                            return item.node.restaurant.name;
                        }else{
                            return '-';
                        }
                    },
                },
                {
                    'name': 'sector',
                    'label': window.translate('app.product.show.tabs.logs.sector.label'),
                    'ordered': true,
                    'orderType': 'sector',
                    'orderDir': 'ASC',
                    'class': 'product-logs-sector',
                    'render': function(item,index){
                        if(item.node.sector && item.node.sector.id > 0){
                            return item.node.sector.name;
                        }else{
                            return '-';
                        }
                    },
                },
                {
                    'name': 'type',
                    'label': window.translate('app.product.show.tabs.logs.type.label'),
                    'ordered': true,
                    'orderType': 'type',
                    'orderDir': 'ASC',
                    'class': 'product-logs-type',
                    'render': function(item,index){
                        let type = item.node.type;
                        return window.translate('app.product.show.tabs.logs.type.'+type);
                    },
                },
                {
                    'name': 'oldPrice',
                    'label': window.translate('app.product.show.tabs.logs.oldPrice.label'),
                    'ordered': true,
                    'orderType': 'oldPrice',
                    'orderDir': 'ASC',
                    'class': 'product-logs-oldPrice',
                    'render': function(item,index){
                        return window.formatFloat(item.node.oldPrice,2) + ' &euro;';
                    },
                },
                {
                    'name': 'newPrice',
                    'label': window.translate('app.product.show.tabs.logs.newPrice.label'),
                    'ordered': true,
                    'orderType': 'newPrice',
                    'orderDir': 'ASC',
                    'class': 'product-logs-newPrice',
                    'render': function(item,index){
                        return window.formatFloat(item.node.newPrice,2) + ' &euro;';
                    },
                },

            ]
        })
    }


    buildGraphQLParameters(){
        let filters = {
            'product': this.product.id,
        };

        let orderBy = 'createdAt';
        let dir = "DESC";
        let parameters = {
            'filter' : filters,

            'orderBy': orderBy,
            'dir': dir,
        };


        return parameters;
    }

}

module.exports = LogsTab;

